// extracted by mini-css-extract-plugin
export default {"heading":"_49k3fQyjdsNKeMuxR56hXL"};